import { render, staticRenderFns } from "./WebviewCallCard.vue?vue&type=template&id=4f282c49"
import script from "./WebviewCallCard.vue?vue&type=script&lang=js"
export * from "./WebviewCallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports